import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ContractService } from '../../../_services';
import { ContractIfrsBase } from "./base/contract-ifrs.base";

@Component({
	selector: 'c-results-from-inputs',
	template: require('./c-results-from-inputs.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class ResultsFromInputs extends ContractIfrsBase implements OnInit {

	constructor(contractService: ContractService) {
		super(contractService);
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/c-results-from-inputs.component.ts